<script setup>
defineProps({
  // Array of [groupTitle, links:[[label, href]]]
  groups: { type: Array, default: () => [] }
})
</script>

<template>
  <section class="block tight" v-for="(group, i) in groups" :key="i">
    <div class="wrap">
      <div class="sec-h"><h2>{{ group[0] }}</h2></div>
      <div class="cloud">
        <NuxtLink
          v-for="(link, j) in group[1]"
          :key="j"
          :to="ftHref(link[1])"
        >{{ link[0] }}</NuxtLink>
      </div>
    </div>
  </section>
</template>
